import React, { Component } from 'react';
import { connect } from 'react-redux';
import { pushModal, initModal } from 'shared/actions/modal.action';
import { getCustomerReviewRequest } from 'shared/actions/customer.action';
import ReviewContents from 'shared/components/selling/ReviewContents';
import Dim from 'web/components/common/modal/common/Dim';

@connect(
  state => {
    return { review: state.shared.customer.review };
  },
  {
    getCustomerReviewRequest,
    pushModal,
    initModal,
  },
)
class NewReviewContainer extends Component {
  componentDidMount() {
    this.props.getCustomerReviewRequest();
  }

  render() {
    const { review } = this.props;

    const handleModalClose = () => {
      this.props.initModal();
    };

    const handleReviewShow = idx => {
      // // console.log({ idx, review });
      this.props.pushModal({
        type: 'ReviewModalMobile',
        data: {
          idx,
        },
      });
    };

    return (
      <Dim style={{ overflow: 'scroll' }}>
        <ReviewContents
          review={review}
          handleModalClose={handleModalClose}
          handleReviewShow={handleReviewShow}
        />
      </Dim>
    );
  }
}

export default NewReviewContainer;
